export const MODELS_CONSULTATION_SOURCES = [
  "models_consultation",
  "models_callback",
] as const;

export type ModelsConsultationSource =
  (typeof MODELS_CONSULTATION_SOURCES)[number];

export const MODELS_CONSULTATION_SOURCE = "models_consultation";
export const MODELS_CALLBACK_SOURCE = "models_callback";

export const MODELS_CONSULTATION_TITLE = "Model Consultation";
export const MODELS_CALLBACK_TITLE = "Model Callback Request";

/** Default short link for the models consultation Google Appointment schedule. */
export const DEFAULT_MODELS_CONSULTATION_BOOKING_URL =
  "https://calendar.app.google/sXfD4vtRx8fTqkrQ6";

/**
 * Embeddable Google Appointment schedule URL (iframe).
 * Resolved from the public short link; override via env if the schedule changes.
 */
export const DEFAULT_MODELS_CONSULTATION_SCHEDULE_EMBED_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ3Jm1Bm-Ei9He5dUs3VMD3ucSAigOZ2ToXfvvqnrsf-ObFnjZ53j0BYLHqWwvcFfCggkcAe0xOr?gv=true";

export function getModelsConsultationBookingUrl() {
  return (
    process.env.NEXT_PUBLIC_MODELS_CONSULTATION_BOOKING_URL ||
    DEFAULT_MODELS_CONSULTATION_BOOKING_URL
  );
}

export function getModelsConsultationScheduleEmbedUrl() {
  return (
    process.env.NEXT_PUBLIC_MODELS_CONSULTATION_SCHEDULE_EMBED_URL ||
    DEFAULT_MODELS_CONSULTATION_SCHEDULE_EMBED_URL
  );
}

export function isModelsConsultationSource(
  source?: string | null,
): source is ModelsConsultationSource {
  return MODELS_CONSULTATION_SOURCES.includes(
    source as ModelsConsultationSource,
  );
}
